module.exports = __webpack_public_path__ + "img/四川天府新区新兴中学.63dce125.jpg";